import { $uniUP } from "../.."
import angular from "angular"

class SidebarTooltipClickController implements ng.IComponentController {
    private $anchor: JQLite
    private $code: JQLite
    private title: string

    constructor(
        private $element: JQLite,
        private $timeout: ng.ITimeoutService,
        private $window: ng.IWindowService,
        private $log: ng.ILogService
    ) { }

    $onInit() {
        this.$log.info("Instanciando sidebar tooltip click", this.title)

        this.$anchor = this.$element.find("span")

        this.$anchor.on("click", {}, $ev => {
            this.$log.info("Binding", this)
            angular.bind(this, this.crearTippy, $ev)()
        })
    }

    crearTippy($event: JQueryEventObject) {
        this.$log.info("Creando tippy sidebar tooltip click", this.title)

        let title =
            this.title || this.$anchor.attr("title") || this.$anchor.attr("title-dev")

        // toggle json-formatter si existe
        this.$code = this.$code || this.$element.find(".json-formatter-container")
        this.$code.toggleClass("ng-hide")

        if (true) return

        if (false && !title) return
            ; (this.$window as any).tippy(this.$anchor[0], {
                content: title,
                allowHTML: true,
                arrow: true,
                trigger: "click",
                theme: "tip-json",
                // placement: "right",
                popperOptions: {
                    modifiers: {
                        preventOverflow: {
                            boundariesElement: "window"
                        }
                    }
                }
            })
    }
}
/**
 * Panel lateral de acceso rápido a los tipos de catálogo
 */
$uniUP.component("sidebarTooltipClick", {
    bindings: {
        title: "@"
    },
    controller: SidebarTooltipClickController
    // transclude: true,
    // template : "<ng-transclude></ng-transclude>"
})
